// Google Analytics Tracking Utilities
// Measurement ID: G-TFJ3FKB2FH

/**
 * Initialize analytics tracking
 */
export function initAnalytics() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            initScrollTracking();
            trackEngagementTime();
        });
    } else {
        initScrollTracking();
        trackEngagementTime();
    }
}

/**
 * Track page views
 */
export function trackPageView(pageTitle, pagePath) {
    if (window.gtag) {
        window.gtag('event', 'page_view', {
            page_title: pageTitle,
            page_path: pagePath
        });
    }
}

/**
 * Track custom events
 */
export function trackEvent(eventName, eventParams = {}) {
    if (window.gtag) {
        window.gtag('event', eventName, eventParams);
    }
}

/**
 * Track waitlist form interactions
 */
export function trackWaitlistFormStart() {
    trackEvent('form_start', {
        form_name: 'waitlist_form',
        form_destination: 'waitlist_signup'
    });
}

export function trackWaitlistFormSuccess(email) {
    trackEvent('waitlist_signup', {
        event_category: 'engagement',
        event_label: 'Waitlist Form Submission',
        value: 1
    });

    // Track conversion
    trackEvent('conversion', {
        send_to: 'G-TFJ3FKB2FH',
        value: 1.0,
        currency: 'USD',
        transaction_id: Date.now().toString()
    });
}

export function trackWaitlistFormError(errorMessage) {
    trackEvent('form_error', {
        form_name: 'waitlist_form',
        error_message: errorMessage
    });
}

/**
 * Track CTA button clicks
 */
export function trackCTAClick(ctaName, ctaLocation) {
    trackEvent('cta_click', {
        cta_name: ctaName,
        cta_location: ctaLocation
    });
}

/**
 * Track scroll depth
 */
function initScrollTracking() {
    let scrollDepths = [25, 50, 75, 100];
    let triggeredDepths = new Set();

    window.addEventListener('scroll', () => {
        const scrollPercentage = Math.round(
            (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
        );

        scrollDepths.forEach(depth => {
            if (scrollPercentage >= depth && !triggeredDepths.has(depth)) {
                triggeredDepths.add(depth);
                trackEvent('scroll_depth', {
                    percent_scrolled: depth
                });
            }
        });
    });
}

/**
 * Track section visibility
 */
export function trackSectionView(sectionName) {
    trackEvent('section_view', {
        section_name: sectionName
    });
}

/**
 * Track outbound links
 */
export function trackOutboundLink(url, linkText) {
    trackEvent('click', {
        event_category: 'outbound',
        event_label: linkText,
        transport_type: 'beacon',
        url: url
    });
}

/**
 * Track product interest
 */
export function trackProductInterest(productName) {
    trackEvent('view_item', {
        items: [{
            item_name: productName,
            item_category: 'skincare'
        }]
    });
}

/**
 * Track user engagement time
 */
function trackEngagementTime() {
    let startTime = Date.now();

    window.addEventListener('beforeunload', () => {
        const engagementTime = Math.round((Date.now() - startTime) / 1000);

        if (window.gtag) {
            window.gtag('event', 'user_engagement', {
                engagement_time_msec: engagementTime * 1000
            });
        }
    });
}
